import React, { Component } from 'react'
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import Header from "../../features/Layout/Header"
import Heading from "../../features/Heading/index"
import Footer from "../../features/Layout/Footer"
import './Post.css'
import "./Slider.css";
import Slider from "./Slider";
import ReactDOM from "react-dom";
import { Form, Input, Button, Select, DatePicker, Divider } from 'antd';
//import 'antd/dist/antd.css';
import './Form.css';





export class BookingForm extends Component {
   state = {
       posts: [],
       isLoaded: false
   }

   from_date = null;
   vacation_id = null;
   to_date = null;
   passengers = null;
   nights = null;

   constructor (props) {
    super(props)
   }
   

   componentDidMount () {
    //https://blog.afnu.co.il/wp-json/wp/v2/posts?slug=about
    axios.get(`https://blog.afnu.co.il/wp-json/wp/v2/posts/?slug=${this.props.match.params.id}`)
        .then(res => this.setState({
            posts: res.data,
            isLoaded: true,
            inlineStyles: this.inlineStyles,
        }, this.initializeSliders))
        .catch(err => console.log(err));

    }
   
    onFinish = (values) => {
        console.log('Form Values:', values);
        alert(this.props.t('pages.postForm.errors.submissionFailed'))
    };
    

   render() {
        //const { postContent, inlineStyles } = this.state;

         // Get the query string from the URL
        const queryString = window.location.search;

        // Parse the query string using URLSearchParams
        const searchParams = new URLSearchParams(queryString);

        // Get the value of a specific parameter
        const booking_type = searchParams.get('type');
        const { t } = this.props;

        if (booking_type != 'standard' && booking_type!='flex') {
            return <div>{t('common.errors.invalidParameter')}</div>;
        }
       

        let strActiveMenu = "main";
        let hideMainImage=false;
       
        return (
        

        <div className="App">  
        <link rel="stylesheet" href="/assets/bootstrap@5.1.3/css/bootstrap.min.css" />

        {/* Inline styles */}

            <Header activeMenu={strActiveMenu} hide={hideMainImage} hideSearchBox={true} className="hidden" hideSearch={true} />
            <main className={this.props.match.params.id} style={this.state.isLoaded?{}:{background:'#fff'}}>

            <link rel="stylesheet" href="/assets/bootstrap@5.1.3/css/bootstrap.min.css" />

            <link rel='stylesheet' id='wp-block-image-rtl-css' href='https://blog.afnu.co.il/wp-includes/blocks/image/style-rtl.min.css?ver=6.7.1' media='all' />

            <link rel="stylesheet" href="/assets/antd/dist/antd.css" />

            <div className={this.state.isLoaded?'wave':'hidden'}>
                    <svg viewBox="0 0 1500 62" fill="none" xmlns="http://www.w3.org/2000/svg" style={{minHeight:'40px'}}>
                        <path transform="scale(1)" fillRule="evenodd" clipRule="evenodd" d="M2748.4,38.1c-211.5-0.3-438.7,84.6-634.5-0.8c-190-82.9-394.4,85.4-609.5-0.7c-204.9-82.1-433,86.2-650.9-0.8
                C659-41.9,412.2,122.7,235.7,35c-157-78-314.4,87.7-513-0.6C-444.1-39.8-635.1,34-814,33.7v89h3562.4V38.1z" fill="#eee"></path></svg>
            </div>
            <img src='/images/Iphone-spinner-2.gif' width='64' height='64' className={this.state.isLoaded?'hidden':''}></img>

            <div className="booking-form-container">

                {this.state.posts.map(post => {
                this.nights = post.nights;
                this.from_date = post.from_date;
                this.vacation_id = post.vacation_id;
                this.to_date = post.to_date;
                this.passengers = post.passengers;

                return (
                    <div key={post.slug} id="vacation">
                        <h1 dangerouslySetInnerHTML={{__html: t('pages.postForm.title') + " " + post.title.rendered}}></h1>
                        {<img src={post.jetpack_featured_media_url} className="booking-form-vacation-image"></img>}
                        {/*<div dangerouslySetInnerHTML={{__html: post.content.rendered}}></div>*/}
                    </div>
                    )}
                )}
            </div>
            

            <div className="container my-1 booking_form">
                <Form
                    layout="vertical"
                    onFinish={this.onFinish}
                >


                     {/* Vacation Details */}
                     <h3 className="mb-3">{t('pages.postForm.sections.vacationDetails')}</h3>
                    <div className="row details booking-form-details">
                        <div className="col-md-12">
                            <strong>{t('pages.postForm.labels.bookingCode')} </strong> {this.vacation_id}{booking_type=='flex'?'FLX':''}
                        </div>
                        <div className="col-md-12">
                            <strong>{t('pages.postForm.labels.dates')} </strong>
                            {this.from_date} {t('pages.postForm.labels.until')} {this.to_date} ({this.nights} {t('pages.postForm.labels.nights')})
                        </div>
                        <div className="col-md-12">
                            <strong>{t('pages.postForm.labels.composition')} </strong>
                            {this.passengers}
                        </div>


                    </div>


                    {/* Personal Details */}
                    <h3 className="mb-3">{t('pages.postForm.sections.bookerDetails')}</h3>
                    <div className="row contact_form">
                    <div className="col-md-6">
                        <Form.Item
                        label={t('pages.postForm.labels.firstName')}
                        name="firstName"
                        rules={[{ required: true, message: t('pages.postForm.validation.firstNameRequired') }]}
                        >
                        <Input />
                        </Form.Item>
                    </div>
                    <div className="col-md-6">
                        <Form.Item
                        label={t('pages.postForm.labels.lastName')}
                        name="lastName"
                        rules={[{ required: true, message: t('pages.postForm.validation.lastNameRequired') }]}
                        >
                        <Input />
                        </Form.Item>
                    </div>
                    <div className="col-md-6">
                        <Form.Item
                        label={t('pages.postForm.labels.email')}
                        name="email"
                        rules={[
                            { required: true, message: t('pages.postForm.validation.emailRequired') },
                            { type: 'email', message: t('pages.postForm.validation.emailInvalid') },
                        ]}
                        >
                        <Input />
                        </Form.Item>
                    </div>
                    <div className="col-md-6">
                        <Form.Item
                        label={t('pages.postForm.labels.phone')}
                        name="phone"
                        rules={[
                            { required: true, message: t('pages.postForm.validation.phoneRequired') },
                            { pattern: /^[0-9]{10}$/, message: t('pages.postForm.validation.phoneInvalid') },
                        ]}
                        >
                        <Input />
                        </Form.Item>
                    </div>
                    </div>


                    {/* Passenger Details */}
                    <h3 className="mb-3">{t('pages.postForm.sections.passengerDetails')}</h3>
                    <Form.List name="passengers">
                    {(fields, { add, remove }) => (
                        <>
                        {fields.map(({ key, name, fieldKey, ...restField }) => (
                            <div key={key} className="row mb-3 passengers_form">
                                <div className="col-md-3">
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'passengerFirstName']}
                                        fieldKey={[fieldKey, 'passengerFirstName']}
                                        rules={[{ required: true, message: t('pages.postForm.validation.firstNameRequired') }]}
                                        >
                                        <Input placeholder={t('pages.postForm.placeholders.firstName')} />
                                    </Form.Item>
                                </div>
                                <div className="col-md-3">
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'passengerLastName']}
                                        fieldKey={[fieldKey, 'passengerLastName']}
                                        rules={[{ required: true, message: t('pages.postForm.validation.lastNameRequired') }]}
                                        >
                                        <Input placeholder={t('pages.postForm.placeholders.lastName')} />
                                    </Form.Item>
                                </div>
                                <div className="col-md-4">
                                    <Form.Item
                                        {...restField}
                                        fieldKey={[fieldKey, 'passengerBirthDate']}
                                        rules={[{ required: true, message: t('pages.postForm.validation.birthDateRequired') }]}>
                                        <DatePicker
                                            style={{ width: "100%" }}
                                            placeholder={t('pages.postForm.placeholders.birthDate')}
                                            rules={[{ required: true, message: t('pages.postForm.validation.birthDateRequired') }]}
                                            /*onChange={(date) =>
                                            this.handlePassengerChange(index, "birthDate", date)
                                            }*/
                                        />
                                    </Form.Item>
                                </div>
                                <div className="col-md-1 align-items-center booking-form-remove-btn">
                                    <Button type="link" className="remove_btn" danger onClick={() => remove(name) }>{t('pages.postForm.buttons.remove')}</Button>
                            </div>

                            </div>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block>
                            {t('pages.postForm.buttons.addPassenger')}
                            </Button>
                        </Form.Item>
                        </>
                    )}
                    </Form.List>

                    {/* Additional Notes */}
                    <br />
                    <h3 className="mb-3">{t('pages.postForm.sections.additionalNotes')}</h3>
                    <Form.Item name="notes" className="remarks">
                    <Input.TextArea rows={4} />
                    </Form.Item>

                    <br />
                    <Form.Item className="booking-form-submit">
                    <Button type="primary" htmlType="submit" block>
                        {t('pages.postForm.buttons.submit')}
                    </Button>
                    </Form.Item>
                    <br />
                </Form>
                </div>
            </main>
            <Footer />

            
        </div>
       )
   }
}
export default withTranslation()(BookingForm)